import React from 'react';
import BadgesUser from './BadgesUser';

const Badges = () => {

  return (
    <div className="container">
        <h1>Badges 🥇</h1>
        <h2>Earn badges</h2>
        <div className="container">
            <BadgesUser />
        </div>
    </div>
  )
}

export default Badges